

function showVersion()
{
    require(
            ['version'],
            function (version) {
                version.showVersion();
            },
            function (err) {
                console.error('ERROR: ', err.requireType);
                console.error('MODULES: ', err.requireModules);
            }
    );
}

/**
 * Affichage d'une fenêtre modal avec un contenu dynamique
 * @param {string} url URL de la page contenue
 * @param {string} titre Titre de la fenêtre modal
 * @param {string} forChart Indique si c'est pour un full screen ou pas.
 */
function openModalIframe(url, titre, forChart)
{
    require(['modal'], function (modal) {
        modal.openModalIframe(url, titre, forChart);
    });
}


function confirmAction(message, callback)
{
    require(['bootbox'], function (bootbox) {
        bootbox.confirm(message, function (result) {
            if (callback && typeof (callback) === 'function') {
                callback(result);
            }
        });
    });
};
define("commonController", function(){});

